var _style, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#1A1A1A;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st2{fill:#1A1A1A;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.2,179.7H49.8c-27.2,0-49.5-22.3-49.5-49.5V49.8c0-27.2,22.3-49.5,49.5-49.5h80.4 c27.2,0,49.5,22.3,49.5,49.5v80.4C179.7,157.4,157.4,179.7,130.2,179.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.7,44.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.1,68.4v-9.9c0-1.1-0.9-2-2-2s-2,0.9-2,2v9.9c-3,0.8-5.1,3.6-5.1,6.8s2.2,5.9,5.1,6.8v39.6c0,1.1,0.9,2,2,2 s2-0.9,2-2V81.9c2.9-0.9,5-3.6,5-6.8S70,69.3,67.1,68.4z M65,78.2c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1 S66.7,78.2,65,78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.3,99.4V58.5c0-1.1-0.9-2-2-2s-2,0.9-2,2v41.1c-2.8,0.9-4.8,3.6-4.8,6.7s2,5.7,4.8,6.7v8.6c0,1.1,0.9,2,2,2 s2-0.9,2-2v-8.4c3.1-0.8,5.3-3.5,5.3-6.8S95.3,100.2,92.3,99.4z M90.5,109.3c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1 s3.1,1.4,3.1,3.1S92.2,109.3,90.5,109.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122,86.1c0-3-1.9-5.6-4.6-6.6v-21c0-1.1-0.9-2-2-2s-2,0.9-2,2v20.7c-3.2,0.7-5.6,3.5-5.6,6.9s2.4,6.2,5.6,6.9 v28.6c0,1.1,0.9,2,2,2s2-0.9,2-2V92.7C120.1,91.6,122,89.1,122,86.1z M115.7,89c-0.1,0-0.2,0-0.2,0c-0.2,0-0.4,0-0.6,0.1 c-1.6-0.1-2.9-1.4-2.9-3.1c0-1.7,1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1C118,87.5,117,88.7,115.7,89z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d0753662de30438534f5ac454efe53ac.svg";
export { ForwardRef as ReactComponent };